import { apiClient } from "./apiClient";
import type { CurrentAuthUser } from "../types/auth.types"

export const authApi = {
  getMe() {
    return apiClient.get<CurrentAuthUser>("/auth/me");
  },
};
